import { render, staticRenderFns } from "./en.vue?vue&type=template&id=54187a52&scoped=true"
import script from "./en.vue?vue&type=script&lang=js"
export * from "./en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54187a52",
  null
  
)

export default component.exports